// Generated by `bazel run i18n`. Do not edit by hand.
import src_c1a2d0b5 from "./en/src.json";

export default Object.assign(
  {},
  src_c1a2d0b5,
);
